import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from '../store'

// For typescript, we need to specify the types of the useDispatch and useSelector hooks
// Source: https://redux.js.org/usage/migrating-to-modern-redux#migrating-typescript-for-components

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
